<template>
  <el-pagination :size="size" :class="[style.page, style[`page-${props.size}`]]" background>
    <slot />
  </el-pagination>
</template>

<script setup lang="ts">
const props = defineProps({
  size: {
    validator(value: string) {
      return ['large', 'default', 'small'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  }
});

const sizeMap: any = reactive({
  large: 'large',
  default: 'default',
  small: 'small'
});

const size = computed(() => {
  return sizeMap[props.size];
});

</script>

<style lang="scss" module="style">
.page {
  :global {
    --el-pagination-hover-color: var(--gray-gray10);
    --el-pagination-button-bg-color: none;
    --el-disabled-bg-color: none;
    --el-text-color-regular: var(--gray-gray10);

    .number,
    .btn-prev,
    .btn-next {
      &:hover {
        background: var(--gray-gray1) !important;
      }
    }

    .is-active {
      --el-color-primary: var(--gray-gray10);
      --el-color-white: var(--text-text6);
      &:hover {
        background: var(--gray-gray10) !important;
      }
    }
  }

  &-max {
    --el-pagination-button-width: var(--height-max);
    --el-pagination-button-height: var(--height-max);
    --el-pagination-font-size: var(--font-size-max);

    :global {

      .number,
      .btn-prev,
      .btn-next {
        min-width: var(--el-pagination-button-width) !important;
        height: var(--el-pagination-button-height) !important;
        border-radius: var(--radius-max) !important;
      }
    }
  }
  
  &-large {
    --el-pagination-button-width: var(--height-large);
    --el-pagination-button-height: var(--height-large);
    --el-pagination-font-size: var(--font-size-max);

    :global {

      .number,
      .btn-prev,
      .btn-next {
        min-width: var(--el-pagination-button-width) !important;
        height: var(--el-pagination-button-height) !important;
        border-radius: var(--radius-large) !important;
      }
    }
  }

  &-default {
    --el-pagination-button-width: var(--height-default);
    --el-pagination-button-height: var(--height-default);
    --el-pagination-font-size: var(--font-size-default);

    :global {

      .number,
      .btn-prev,
      .btn-next {
        min-width: var(--el-pagination-button-width) !important;
        height: var(--el-pagination-button-height) !important;
        border-radius: var(--radius-default) !important;
      }
    }

  }

  &-small {
    --el-pagination-button-width: var(--height-small);
    --el-pagination-button-height: var(--height-small);
    --el-pagination-font-size: var(--font-size-small);

    :global {
      .number,
      .btn-prev,
      .btn-next {
        min-width: var(--el-pagination-button-width) !important;
        height: var(--el-pagination-button-height) !important;
        border-radius: var(--radius-small) !important;
      }
    }
  }

  &-mini {
    --el-pagination-button-width: var(--height-mini);
    --el-pagination-button-height: var(--height-mini);
    --el-pagination-font-size: var(--font-size-mini);

    :global {
      .number,
      .btn-prev,
      .btn-next {
        min-width: var(--el-pagination-button-width) !important;
        height: var(--el-pagination-button-height) !important;
        border-radius: var(--radius-mini) !important;
      }
    }
  }
}

html[dir="rtl"] {
  .page {
    :global {
      .is-first,
      .is-last {
        transform: scaleX(-1);
      }
    }
  }
}
</style>
